//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "managerPassword",
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    portalid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      openResume: false,
      statusImg: {
        true: require("../../../../assets/images/success.png"),
        false: require("../../../../assets/images/error1.png"),
      },
      ifpassworderror: false, //是否展示密码验证失败提示信息
      passwordpass: false, //验证密码是否验证成功
      passworderror: false, //验证密码是否验证失败
      passwordpass2: false, //验证密码是否验证成功
      passworderror2: false, //验证密码是否验证失败
      passcurrpassword: false, //验证当前密码是否通过
    };
  },
  methods: {
    checkCurrPassword() {
      //验证当前密码
      let checkUrl = "api/api/portalLogin/checkPassword";
      let params = {
        portalid: this.portalid,
        password: this.record.currpassword,
      };
      this.axios
        .post(checkUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
              return;
            }
            this.passcurrpassword = true;
          }
        })
        .catch((error) => console.log(error));
    },
    checkPassword() {
      //正则验证密码
      let flag = true;
      if (!this.isNotNullOrEmpty(this.record.newpassword)) {
        //this.tipDefault("Please Enter Password First");
        this.ifpassworderror = false;
        flag = false;
      } else {
        //校验邮箱是否符合规范
        let password = this.record.newpassword;
        let checkReg =
          /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&_*,\.])[0-9a-zA-Z!@#$%^&_*,\\.]{7,}$/;
        //^.* 指任意字符
        //(?=.*[0-9])任意字符串后有一数字
        //(?=.*[A-Z])任意字符串后有一大写字母
        //(?=.*[a-z])任意字符串后有一小写字母
        //(?=.*[!@#$%^&*?])任意字符串后有一括号里的特殊字符
        //\w{7,}   指长度要大于8位
        if (!checkReg.test(password)) {
          this.ifpassworderror = true;
          this.passworderror = true;
          this.passwordpass = false;
          flag = false;
        } else {
          this.passwordpass = true;
          this.passworderror = false;
          this.ifpassworderror = false;
        }
      }
      return flag;
    },
    checkPassword2() {
      //验证再次输入密码是否正确
      let newpassword = this.record.newpassword;
      let password2 = this.record.password2;
      if (this.isNotNullOrEmpty(password2)) {
        if (password2 != newpassword) {
          this.passwordpass2 = false;
          this.passworderror2 = true;
        } else {
          this.passworderror2 = false;
          this.passwordpass2 = true;
        }
      }
    },
    async updatePassword() {
      if (!this.passwordpass || !this.passwordpass2 || !this.passcurrpassword) {
        this.$msgDailog.showMsgBox({
          title: "New password doesn't match the validation rule.",
        });
        return false;
      }
      if(!this.isNotNullOrEmpty(this.record.currpassword)){
         this.$msgDailog.showMsgBox({
          title: "Current Password doesn't Empty",
        });
        return false;
      }
      //修改密码URL
      let params = {
        record: {
          portalid: this.portalid,
          password: this.record.newpassword,
          currpassword: this.record.currpassword,

        },
      };
      let changeUrl = "api/api/portalLogin/updatePassword"; //修改密码URL
      this.axios
        .post(changeUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
            } else {
              this.$router.push({
                path: "/portal/successOperate",
                query: {
                  showtype: "update",
                },
              });
            }
          }
        })
        .catch((error) => console.log(error));
    },
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/managerPassword.vue